module.exports = __webpack_public_path__ + "static/media/vanity-fair.6ca9c10e.svg";